





















import { defineComponent } from "@vue/composition-api";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import BaseImage from "@/components/BaseImage";

export default defineComponent({
  name: "ContentCover",
  components: { BaseImage },
  props: {
    size: { type: String, default: "100%" },
    type: {
      type: String,
      default: "",
      validator: (v: string) => ["", ContentFeedTypeEnum.EVENT, ContentFeedTypeEnum.MEDIA].includes(v),
    },
  },
});
